import * as React from 'react';
import { SVGProps } from 'react';

const IconPinSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.2 1.225 10.775 2.8c.3.3.3.788 0 1.088L8.127 6.536l.066.118c.501.901.526 1.953-.203 2.682l-.998.998-1.998-1.997L1.666 11 1 10.334l2.663-3.328-1.997-1.998.998-.998c.73-.73 1.78-.704 2.682-.203l.118.066 2.648-2.648c.3-.3.788-.3 1.088 0Z" />
  </svg>
);
export default IconPinSizeXs;
